import {
  milestoneVar
} from './variables';

export function setMilestone( newValue ) {
  milestoneVar( newValue );
}